<template>
  <div id="Home">

    <!-- Structured Race Evenings Popup -->
    <div v-if="acf.acf.show_pop_up == true">
      <div
        v-if="showRacePopup"
        class="race-popup-overlay"
        @click.self="closeRacePopup"
      >
        <div
          class="race-popup"
          role="dialog"
          aria-modal="true"
          aria-labelledby="race-popup-title"
        >
          <button
            class="race-popup-close"
            type="button"
            aria-label="Close popup"
            @click="closeRacePopup"
          >
            &times;
          </button>

          <div class="race-popup-image">
            <div class="race-popup-image-overlay"></div>

            <div class="race-popup-content">
              <span class="race-popup-tag">
                {{acf.acf.pop_up_tag}}
              </span>

              <h2 id="race-popup-title">
                {{acf.acf.pop_up_title}}
              </h2>

              <p class="race-popup-month">
                {{acf.acf.pop_up_month}}
              </p>

              <p class="race-popup-description" v-html="acf.acf.pop_up_description">
              </p>

                <button
                  type="button"
                  class="race-popup-button"
                  @click="goToRaceEvenings"
                >
                  FIND OUT MORE
                  <span>&rarr;</span>
                </button>

              <button
                type="button"
                class="race-popup-dismiss"
                @click="closeRacePopup"
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Home /> -->
    <HomeTopImage />
    <EnquireyBanner />
    <BannerPrice />
    <template v-if="isMobile(true)">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2025/07/495266403_122130807848757365_4536100922264432901_n-1.jpg">
    </template>
    <template v-if="isMobile(true)">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2025/02/IMG_1876-scaled.jpg">
    </template>
    <template v-else>
      <GolfParkImages />
    </template>
    <div id="structured-race-evenings" class="bkPack">
      <Packages />
    </div>
    <div id="membership">
      <GolfMember />
    </div>
    <div id="about" style="margin-bottom:80px">
      <AboutTrackman />
    </div>
     <div class="AppSection">
      <b-container>
        <template v-if="isMobile(true)">
          <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
            <img class="BookNowApp" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2024/11/BookNOw_Mobile_Banner_2-1.png">
            <b-row>
              <b-col>
              </b-col>
              <b-col>
                <b-row cols="placementmob">
                  <b-col>
                    <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="BookNowAppAppleMob" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/AppleAppStore.png">
                    </b-link>
                  </b-col>
                  <b-col>
                    <b-link :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="BookNowAppGoogleMob" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/GooglePlay.png">
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-link>
        </template>
        <template v-else>
          <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
            <img class="BookNowApp" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2024/11/DownloadAppBanner_1.png">
            <b-row>
              <b-col>
              </b-col>
              <b-col>
                <b-row cols="placement">
                  <b-col>
                    <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="BookNowAppApple" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/AppleAppStore.png">
                    </b-link>
                  </b-col>
                  <b-col>
                    <b-link :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="BookNowAppGoogle" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/GooglePlay.png">
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-link>
        </template>
      </b-container>
    </div>
    <div class="questionsSection">
       <Questions />
    </div>
    <template v-if="isMobile(true)">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2025/02/IMG_1818.png">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2025/02/IMG_1863.png">
    </template>
  </div>
</template>

<script>
import HomeTopImage from '@/components/HomeTopImage.vue'
import EnquireyBanner from '@/components/EnquireyBannerOne.vue'
import AboutTrackman from '@/components/AboutTrackman.vue'
import GolfParkImages from '@/components/GolfParkImages.vue'
import GolfMember from '@/components/GolfParkMember.vue'
import Questions from '@/components/QuestionandAnswers.vue'
import Packages from '@/components/Packages.vue'
import BannerPrice from '@/components/BannerPrice.vue'
import axios from 'axios'
export default {
  name: 'App',
  data() {
    return {
      showRacePopup: false,
      acf: null
    }
  },
  components: {
    HomeTopImage,
    EnquireyBanner,
    AboutTrackman,
    GolfParkImages,
    GolfMember,
    Questions,
    Packages,
    BannerPrice
  },
  methods: {
    isMobile() {
      return screen.width <= 768
    },

    closeRacePopup() {
      this.showRacePopup = false
      sessionStorage.setItem('racePopupDismissed', 'true')
    },
    goToRaceEvenings() {
      this.closeRacePopup()

      this.$nextTick(() => {
        const section = document.getElementById('structured-race-evenings')

        if (section) {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      })
    }
  },


mounted() {
  setTimeout(() => {
    this.showRacePopup = true;
  }, 400);

  const cacheKey = "racepark-page-4-acf";

  // Show previously saved WordPress data immediately
  try {
    const cachedData = localStorage.getItem(cacheKey);

    if (cachedData) {
      this.acf = JSON.parse(cachedData);
    }
  } catch (error) {
    console.warn("Could not read cached ACF data:", error);
  }

  // Fetch the latest data in the background
  axios
    .get(
      process.env.VUE_APP_API_URL +
      "racepark/wp-json/wp/v2/pages/4"
    )
    .then((response) => {
      this.acf = response.data;

      try {
        localStorage.setItem(cacheKey, JSON.stringify(response.data));
      } catch (error) {
        console.warn("Could not cache ACF data:", error);
      }
    })
    .catch((error) => {
      console.error("Could not load WordPress page data:", error);
    });
}

}
</script>
<style scoped>

/* RacePark November event popup */

.race-popup-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.82);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: raceOverlayFade 0.3s ease;
}

.race-popup {
  position: relative;
  width: 100%;
  max-width: 760px;
  overflow: hidden;
  background: #111;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.55);
  animation: racePopupEnter 0.35s ease;
}

.race-popup-image {
  position: relative;
  min-height: 440px;
  display: flex;
  align-items: center;
  background-color: #171717;

  background-image:
    linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.96) 0%,
      rgba(0, 0, 0, 0.82) 55%,
      rgba(0, 0, 0, 0.3) 100%
    ),
    url('https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2026/10/IMG_7394-1.png');

  background-size: cover;
  background-position: center;
}

.race-popup-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(216, 14, 31, 0.16),
    transparent 55%
  );
  pointer-events: none;
}

.race-popup-content {
  position: relative;
  z-index: 1;
  max-width: 510px;
  padding: 55px 48px 45px;
  color: #fff;
}

.race-popup-tag {
  display: inline-block;
  margin-bottom: 20px;
  padding: 8px 12px;
  color: #fff;
  background: #d80e1f;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
}

.race-popup-content h2 {
  margin: 0 0 8px;
  color: #fff;
  font-size: clamp(30px, 5vw, 46px);
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: -1px;
}

.race-popup-month {
  margin: 12px 0 20px;
  color: #ff3344;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 5px;
}

.race-popup-description {
  max-width: 400px;
  margin-bottom: 28px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 16px;
  line-height: 1.7;
}

.race-popup-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  min-width: 220px;
  padding: 16px 22px;
  color: #fff !important;
  background: #d80e1f;
  border: 2px solid #d80e1f;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 1px;
  text-decoration: none !important;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}

.race-popup-button:hover {
  color: #fff !important;
  background: #a90a17;
  border-color: #a90a17;
  transform: translateY(-2px);
}

.race-popup-button span {
  font-size: 21px;
  line-height: 1;
}

.race-popup-dismiss {
  display: block;
  margin-top: 17px;
  padding: 5px 0;
  color: rgba(255, 255, 255, 0.65);
  background: transparent;
  border: 0;
  font-size: 13px;
  cursor: pointer;
}

.race-popup-dismiss:hover {
  color: #fff;
}

.race-popup-close {
  position: absolute;
  top: 13px;
  right: 15px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  font-size: 27px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease;
}

.race-popup-close:hover {
  background: #d80e1f;
}

@keyframes raceOverlayFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes racePopupEnter {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media only screen and (max-width: 600px) {
  .race-popup-overlay {
    padding: 14px;
  }

  .race-popup {
    max-width: 440px;
    border-radius: 12px;
  }

  .race-popup-image {
    min-height: 460px;
    background-position: 60% center;
  }

  .race-popup-content {
    padding: 55px 25px 30px;
  }

  .race-popup-content h2 {
    font-size: 34px;
  }

  .race-popup-description {
    font-size: 14px;
    line-height: 1.65;
  }

  .race-popup-button {
    width: 100%;
    box-sizing: border-box;
  }
}

@media (prefers-reduced-motion: reduce) {
  .race-popup-overlay,
  .race-popup {
    animation: none;
  }

  .race-popup-button {
    transition: none;
  }
}

.bkPack {
  background-color: #F2F2F2;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
  .buyGiftVoucher {
    background-color: #d80e1f;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 458px;
    height: 57px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    position: absolute;
    top: 10.5em;
    z-index: 99;
    margin-left: 10em;
    cursor: pointer;
  }
  .buyGiftVoucher:hover {
    background-color: #000000;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 458px;
    height: 57px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    position: absolute;
    top: 10.5em;
    z-index: 99;
    margin-left: 10em;
    cursor: pointer;
  }
  p.leaderboards {
    width: 70%;
    text-align: center;
    margin: auto;
    padding-bottom: 70px;
    font-size: 24px;
    color: #fff;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  h2.Whitetitle.RA {
    padding-top: 50px;
    padding-bottom: 20px;
  }
  #hotLap {
    background-color: #D80E1F;
    padding-bottom: 100px;
  }
  img.BookNowAppApple {
    width: 220px;
  }
  img.BookNowAppGoogle {
    width: 220px;
  }
  .row.row-cols-placement {
    position: absolute;
    top: -9em;
    left: 8em;
  }
  .AppSection {
    padding-bottom: 100px;
  }
  ::v-deep .btn-danger {
    color: #fff;
    background-color: #7ebd63;
    border-color: #7ebd63!important;
  }
  .imagesInsert {
    width: 100%;
  }
  .BookNowApp {
    width: 100%;
  }
  @media only screen and (max-width: 1280px) {
    .buyGiftVoucher {
        background-color: #d80e1f;
        border-color: #d80e1f !important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 458px;
        height: 57px;
        /* margin-top: 65px; */
        font-family: "noto-sans", sans-serif;
        border: none;
        position: absolute;
        top: 10.5em;
        z-index: 99;
        margin-left: 5em;
        cursor: pointer;
    }
    .buyGiftVouche:hover {
        background-color: #000000;
        border-color: #000000 !important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 458px;
        height: 57px;
        /* margin-top: 65px; */
        font-family: "noto-sans", sans-serif;
        border: none;
        position: absolute;
        top: 10.5em;
        z-index: 99;
        margin-left: 5em;
        cursor: pointer;
    }
  }
  @media only screen and (max-width: 1260px) {
    .row.row-cols-placement {
      position: absolute;
      top: -8em;
      left: 6em;
    }
  }
  @media only screen and (max-width: 1230px) {
    .row.row-cols-placement {
      position: absolute;
      top: -8em;
      left: 6em;
    }
  }
  @media only screen and (max-width: 1200px) {
    img.BookNowAppGoogle {
      width: 160px;
    }
    img.BookNowAppApple{
      width: 160px;
    }
    .row.row-cols-placement {
      position: absolute;
      top: -6.5em;
      left: 6em;
    }
  }
  @media only screen and (max-width: 990px) {
    img.BookNowAppGoogle {
      width: 110px;
    }
    img.BookNowAppApple{
      width: 110px;
    }
    .row.row-cols-placement {
      position: absolute;
      top: -4.5em;
      left: 4em;
    }
  }

  /* mobileAd */
  .row.row-cols-placementmob {
    position: absolute;
    top: -6.5em;
    left: -5em;
  }
  img.BookNowAppGoogleMob {
    width: 150px;
  }
  img.BookNowAppAppleMob{
    width: 150px;
  }
  @media only screen and (max-width: 767px) {
    img.BookNowAppAppleMob {
      width: 110px;
    }
    img.BookNowAppGoogleMob{
      width: 110px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -4.5em;
      left: -4em;
    }
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 458px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 10.5em;
      z-index: 99;
      margin-left: 7em;
      cursor: pointer;
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 458px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 10.5em;
      z-index: 99;
      margin-left: 7em;
      cursor: pointer;
      left: 0;
      right: 0;
    }
  }
    @media only screen and (max-width: 500px) {
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
  }
  @media only screen and (max-width: 425px) {
    img.BookNowAppAppleMob {
      width: 100px;
    }
    img.BookNowAppGoogleMob{
      width: 100px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -3.6em;
      left: -4em;
    }
  }
  @media only screen and (max-width: 396px) {
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 2.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 2.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
  }
  @media only screen and (max-width: 375px) {
    img.BookNowAppAppleMob {
      width: 80px;
    }
    img.BookNowAppGoogleMob{
      width: 80px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -3.1em;
      left: -3.5em;
    }
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 243px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 243px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
  }
  @media only screen and (max-width: 320px) {
    img.BookNowAppAppleMob {
      width: 60px;
    }
    img.BookNowAppGoogleMob{
      width: 60px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -2.7em;
      left: -2.6em;
    }
  }
</style>
